import React, { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { toast } from 'sonner';
import { api } from '@/utils/api';

// Admin: AXE's own borrower-paid fees (separate from lender fees). Defaults 1.5% origination + $1,500 processing.
export const AxeFeesCard = () => {
  const [cfg, setCfg] = useState(null);
  const [form, setForm] = useState({ origination_pct: '', processing_fee: '' });
  const load = () => api.get('/pricing/axe-fees').then((r) => { setCfg(r.data); setForm({ origination_pct: (r.data.origination_pct * 100).toString(), processing_fee: r.data.processing_fee.toString() }); });
  useEffect(() => { load().catch(() => {}); }, []);
  const save = async () => {
    try {
      await api.put('/pricing/axe-fees', { origination_pct: Number(form.origination_pct) / 100, processing_fee: Number(form.processing_fee) });
      toast.success('AXE fees saved — new quotes and term sheets use them'); await load();
    } catch (e) { toast.error(e.response?.data?.detail || 'Save failed'); }
  };
  const ex = cfg?.example_300k;
  return (
    <section className="border rounded-xl p-4 space-y-3" data-testid="axe-fees-section">
      <div>
        <h2 className="font-semibold">AXE standard fees (borrower-paid, shown on every term sheet)</h2>
        <p className="text-xs text-muted-foreground">Origination % of the total loan + flat processing fee. Listed separately from lender fees and included in cash to close. If a lender's minimum origination is higher, the quote uses the lender minimum and says so.</p>
      </div>
      <div className="grid sm:grid-cols-3 gap-3 items-end">
        <div><label className="text-xs text-muted-foreground">Origination fee (%)</label><Input type="number" step="0.125" value={form.origination_pct} onChange={(e) => setForm({ ...form, origination_pct: e.target.value })} data-testid="axe-orig-input" /></div>
        <div><label className="text-xs text-muted-foreground">Processing fee ($)</label><Input type="number" step="50" value={form.processing_fee} onChange={(e) => setForm({ ...form, processing_fee: e.target.value })} data-testid="axe-proc-input" /></div>
        <Button size="sm" onClick={save} data-testid="axe-fees-save-btn">Save AXE fees</Button>
      </div>
      {ex && <p className="text-xs text-muted-foreground" data-testid="axe-fees-example">Example $300,000 loan: {ex.axe_origination_fee.value} + {ex.axe_processing_fee.value} = <b>{ex.axe_fees_total.value}</b> (defaults {cfg.defaults.origination_pct * 100}% / ${cfg.defaults.processing_fee})</p>}
    </section>
  );
};

export default AxeFeesCard;
